// extracted by mini-css-extract-plugin
module.exports = {"body":"LifeCycleModal_body__399v0","descriptionList":"LifeCycleModal_descriptionList__JWGPF"};